import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: "Review Pending Content",
      description: "8 items awaiting approval",
      icon: "Clock",
      color: "warning",
      action: () => navigate('/artist-detail-editor-view?filter=pending'),
      badge: "8"
    },
    {
      title: "Mobile App Preview",
      description: "Test artist profiles",
      icon: "Smartphone",
      color: "accent",
      action: () => navigate('/mobile-app-preview')
    },
    {
      title: "Content Analytics",
      description: "View performance metrics",
      icon: "BarChart3",
      color: "success",
      action: () => navigate('/editor-dashboard?tab=analytics')
    },
    {
      title: "Artist Management",
      description: "Manage all artists",
      icon: "Users",
      color: "primary",
      action: () => navigate('/artist-content-management')
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'warning':
        return 'bg-warning text-warning-foreground';
      case 'success':
        return 'bg-success text-success-foreground';
      case 'accent':
        return 'bg-accent text-accent-foreground';
      default:
        return 'bg-primary text-primary-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg elevation-1">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-text-primary">Quick Actions</h3>
        <p className="text-sm text-text-secondary mt-1">
          Common editor tasks and shortcuts
        </p>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {quickActions?.map((action, index) => (
            <div
              key={index}
              className="p-4 border border-border rounded-lg hover:bg-muted transition-smooth cursor-pointer group"
              onClick={action?.action}
            >
              <div className="flex items-start space-x-3">
                <div className={`p-2 rounded-lg ${getColorClasses(action?.color)} group-hover:scale-105 transition-transform`}>
                  <Icon name={action?.icon} size={20} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2">
                    <h4 className="text-sm font-medium text-text-primary group-hover:text-accent transition-colors">
                      {action?.title}
                    </h4>
                    {action?.badge && (
                      <span className="px-2 py-1 text-xs bg-warning text-warning-foreground rounded-full">
                        {action?.badge}
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-text-secondary mt-1">
                    {action?.description}
                  </p>
                </div>
                
                <Icon 
                  name="ArrowRight" 
                  size={14} 
                  className="text-text-secondary group-hover:text-accent group-hover:translate-x-1 transition-all" 
                />
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-4 pt-3 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Settings"
            iconPosition="left"
          >
            Customize Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;